import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { CustomTextField } from "../../../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import { saveSubTask } from "../../../../services/usersService";
import { DialogActions } from "@material-ui/core";
function SubTaskForm({ taskID = 0, onConfirmSave, onCloseSubTask }) {
  let subTaskData = {
    taskID,
    description: "",
  };
  const subTaskSchema = yup.object().shape({
    ID: yup.number(),
    description: yup.string(),
  });
  return (
    <Formik
      initialValues={subTaskData}
      validationSchema={subTaskSchema}
      enableReinitialize={true}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        saveSubTask(values)
          .then((response) => {
            resetForm();
            onConfirmSave();
          })
          .catch((errors) => {});
      }}
    >
      {({
        values,
        status,
        dirty,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <CustomTextField
            label="Sub Task Description"
            propertyName="description"
            onBlur={handleBlur}
            onChange={handleChange}
            values={values}
            touched={touched}
            errors={errors}
            size="small"
            margin="none"
          />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={() => {
                onCloseSubTask();
              }}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold"
              onClick={handleSubmit}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
}

export default SubTaskForm;
